import Alert from '@mui/material/Alert'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

export const TableError = ({ colSpan }: { colSpan: number }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ p: 0, m: 0, border: 0 }}>
        <Alert severity="error" sx={{ justifyContent: 'center' }}>
          Er is iets misgegaan. Probeer het later opnieuw.
        </Alert>
      </TableCell>
    </TableRow>
  )
}
